import { EyeIcon } from "@heroicons/react/24/outline";
import LibraryRequestMenuItem from "./LibraryRequestMenuItem";

export default function LibraryRequestPreviewMenuItem({ onOpen }) {
  return (
    <LibraryRequestMenuItem
      onClick={(event) => {
        event.stopPropagation();
        onOpen?.();
      }}
    >
      <EyeIcon className="w-[16px] h-[16px]" />
      <span>Preview Report</span>
    </LibraryRequestMenuItem>
  );
}
